export const toInitials = (name, fallback = "") => {
  const trimmed = (name ?? "").trim();
  if (!trimmed) {
    return (fallback ?? "").slice(0, 2).toUpperCase();
  }
  const tokens = trimmed.split(/\s+/);
  if (tokens.length >= 2) {
    return (tokens[0][0] + tokens.at(-1)[0]).toUpperCase();
  }
  return trimmed.slice(0, 2).toUpperCase();
};

// Separators as well as spaces, so an account named for its email still reads as a person.
export const initialsFromName = (displayName) => {
  if (!displayName) {
    return "";
  }

  const words = displayName
    .replace(/@.*$/, "")
    .trim()
    .split(/[\s._-]+/)
    .filter(Boolean);

  if (words.length === 0) {
    return "";
  }
  if (words.length >= 2) {
    return (words[0][0] + words[words.length - 1][0]).toUpperCase();
  }
  return words[0].slice(0, 2).toUpperCase();
};
